import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

// Sign-in and shared links must render without an authenticated organization.
export function PublicShell({
  children,
  centered = true,
  viewport = false,
}: {
  children: ReactNode;
  centered?: boolean;
  viewport?: boolean;
}) {
  return (
    <div className={cn("flex flex-col bg-background", viewport ? "h-svh overflow-hidden" : "min-h-svh")}>
      <header className="flex h-14 shrink-0 items-center px-4 sm:px-10">
        <a href="/" aria-label="Limrun home" className="inline-flex">
          <img src="/logo-wordmark.svg" alt="Limrun" className="h-5 w-auto dark:hidden" />
          <img src="/logo-wordmark-dark.svg" alt="Limrun" className="hidden h-5 w-auto dark:block" />
        </a>
      </header>
      <main
        className={cn(
          "flex min-w-0 flex-1 flex-col px-4 sm:px-10",
          viewport ? "min-h-0 overflow-hidden pb-4 pt-2 sm:pb-6" : "pb-10 pt-6",
          centered && "items-center justify-center",
        )}
      >
        <div className={cn("w-full min-w-0", centered ? "max-w-md" : "flex min-h-0 flex-1 flex-col")}>
          {children}
        </div>
      </main>
    </div>
  );
}
